import merge from 'webpack-merge';

import commonConfig from './default.js';
const envConfig = require(`./${process.env.VUE_APP_ENV}.js`).default;

const config = merge(commonConfig, envConfig);

export default config;
